export default "__VITE_PUBLIC_ASSET__2d597e6a__"